/**
 * JSON.parse for a localStorage value that tolerates "" (what clearLocalStorage writes back for the
 * keys it keeps) and corrupt values.
 */
export const readJson = <T>(key: string, fallback: T): T => {
    try {
        const raw = localStorage.getItem(key);
        if (!raw) return fallback;
        return JSON.parse(raw) as T;
    } catch {
        return fallback;
    }
};
